export enum TaskCapacityLevel {
	LOW = 'low',
	MEDIUM = 'medium',
	HIGH = 'high'
}

const MEDIUM_MIN_RATIO = 0.3;
const HIGH_MIN_RATIO = 0.8;

export const getTaskCapacityLevel = (ratio: number): TaskCapacityLevel => {
	if (ratio >= HIGH_MIN_RATIO) {
		return TaskCapacityLevel.HIGH;
	}
	if (ratio >= MEDIUM_MIN_RATIO) {
		return TaskCapacityLevel.MEDIUM;
	}

	return TaskCapacityLevel.LOW;
};
